// Enums
export enum EmployeeFormTab {
  EMPLOYEE_DETAILS = 'Employee Details',
  RISK_PROFILE = 'Risk Profile',
}

// Interfaces
export interface PhoneNumber {
  value: string;
  country_code: string;
  valid: boolean;
}

export interface FormErrors {
  mobileNumberErrors: string[] | string | Record<string, string | string[]>;
  fallbackNumberErrors: string[] | string | Record<string, string | string[]>;
}

export interface RiskProfile {
  risky: boolean;
  risky_reason: string;
}

export interface Employer {
  id: number;
  company_name: string;
  branches?: Array<{ id: number; name: string }>;
  pay_cycles?: Array<{ id: number; name: string }>;
}

export interface Subscription {
  id: number;
  name: string;
}

export interface TransactionFee {
  id: number;
  fee_type: string;
  fee_amount: number;
  fee_percentage: number;
}

export interface EmployeeData {
  id: number;
  first_name: string;
  last_name: string;
  mobile_number: string;
  fallback_number?: string | null;
  email: string;
  id_number?: string;
  employee_no?: string;
  salary?: number;
  bank_name?: string;
  bank_branch_code?: string;
  bank_account_number?: string;
  risk_metric?: number;
  smartwage_status: string;
  term_cond: boolean;
  risky: boolean;
  risky_reasons?: { reasons: string[] } | null;
  subscription?: number | null;
  transaction_fee?: number | null;
  employer: Employer;
  employee_pay_cycle?: { id: number; name: string };
  employee_pay_cycle_id?: number;
  employee_branch?: { id: number; name: string };
  employee_branch_id?: number;
  start_of_employment_date?: string | null;
  whatsapp_bsuid?: string | null;
  is_temporary: boolean;
  sync_paused_by?: number | null;
  sync_paused_by_name?: string | null;
  sync_pause_reason?: string | null;
  sync_paused_until?: string | null;
}

export interface AuditLog {
  date: string;
  updatedBy: string;
  risky: boolean | null;
  reasons: string[];
}

export const REASON_CATEGORIES = [
  'employer_request_terminated',
  'employer_request_resigned',
  'employer_request_maternity_leave',
  'employer_request_no_explanation',
  'employer_request_banking_details_updated',
  'employer_request_other',
  'employee_request_mobile_number_update',
  'employee_request_unsubscribe',
  'employee_request_change_risk_metric',
  'employee_request_other',
  'other',
] as const;

export type ReasonCategory = typeof REASON_CATEGORIES[number];
